import UdApi from 'api/Ud';
import AcademicApi from 'api/Academic';

import store from 'store';

export default {
  validationError: 'You have not completed this form correctly. Please review each highlighted field and correct.',
  communicationError: 'There was an error communicating with the server. Please try again later.',
  invalidUsernameOrPassword: 'Invalid username and/or password supplied. Please try again.',
  accountLocked: 'The account is locked or does not exist.',
  unknownEmailAddress: 'The supplied email address does not exist.',
  unknownUsername: 'The supplied username does not exist.',

  api() {
    return store.state.context === 'academic' ? AcademicApi : UdApi;
  },

  processError(error) {
    if (error.response) {
      if (error.response.data) {
        return error.response.data.message || error.response.data.errorMessage;
      }

      return this.communicationError;
    }

    return this.communicationError;
  },

  login(credentials) {
    return this.api().login(credentials);
  },
  isAccountLocked(credentials) {
    return this.api().isAccountLocked(credentials);
  },
  register(user, type, inviteKey) {
    switch (type) {
      case 'HCP':
        return AcademicApi.registerHcp(user, inviteKey);
      case 'TRAINEE':
        return AcademicApi.registerTrainee(user, inviteKey);
      case 'SUPERVISOR':
        return AcademicApi.registerSupervisor(user, inviteKey);
      case 'HOD':
        return AcademicApi.registerHod(user, inviteKey);
      default:
        return UdApi.register(user);
    }
  },
  requestPasswordReset(username) {
    return this.api().requestPasswordReset(username);
  },
  performPasswordResetWithOtp(credentialsWithOtp) {
    const api = UdApi;
    return api.performPasswordResetWithOtp(credentialsWithOtp);
  },
  requestUsernameReminder(email) {
    const api = UdApi;
    return api.requestUsernameReminder(email);
  },
  performPasswordReset(credentials) {
    return this.api().performPasswordReset(credentials);
  },
  sendContactRequest(contactMeCriteria) {
    const api = UdApi;
    return api.sendContactRequest(contactMeCriteria);
  },
  lookupCountries() {
    const api = UdApi;
    return api.lookupCountries();
  },
  lookupLogbookCountries() {
    return this.api().lookupLogbookCountries();
  },
  lookupDisciplines() {
    return this.api().lookupDisciplines();
  },
  lookupSpecialities(disciplineId) {
    return this.api().lookupSpecialities(disciplineId);
  },
  lookupRolesUd(specialityId) {
    const api = UdApi;
    return api.lookupRoles(specialityId);
  },
  lookupRolesAcademic() {
    const api = AcademicApi;
    return api.lookupRoles();
  },
  searchHods(query) {
    const api = AcademicApi;
    return api.searchHods(query);
  },
  verifyEmail(verifyEmailData) {
    const api = AcademicApi;
    return api.verifyEmail(verifyEmailData);
  },
  fetchPracticeInviteData(inviteKey) {
    return this.api().fetchPracticeInviteData(inviteKey);
  },
  fetchInviteData(inviteKey) {
    return this.api().fetchInviteData(inviteKey);
  },

  fetchPracticeNameAutocomplete(searchText) {
    return this.api().fetchPracticeNameAutocomplete(searchText);
  },

  fetchPracticeKioskLink(practiceId) {
    return this.api().fetchPracticeKioskLink(practiceId);
  },

  validateAccountDeletionToken(token) {
    return this.api().validateAccountDeletionToken(token);
  },
  deleteAccount(userId, token) {
    return this.api().deleteAccount(userId, token);
  },

  lookupGrades(specialityId) {
    const api = AcademicApi;
    return api.lookupGrades(specialityId);
  },
  lookupInstitutions() {
    const api = AcademicApi;
    return api.lookupInstitutions();
  },
};



// WEBPACK FOOTER //
// ./src/api/Api.js